import PropTypes from 'prop-types';
import hexRgba from 'hex-rgba';

function ImagemapTemplate4({ selected, color, width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0,0,154,154"
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-893 -346) translate(353 254) translate(540 92)">
              <rect
                width={width}
                height={height}
                fill={selected ? color : hexRgba(color, 10)}
                rx="8"
              />
              <path
                fill="#FFF"
                d="M79 0L81 0 81 160 79 160z"
                transform="rotate(-90 80 80)"
              />
              <path fill="#FFF" d="M79 0L81 0 81 160 79 160z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

ImagemapTemplate4.defaultProps = {
  selected: false,
  color: '#2A394D',
  width: 154,
  height: 154,
};

ImagemapTemplate4.propTypes = {
  selected: PropTypes.bool,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ImagemapTemplate4;
